/**
 * Shopify Craft Theme – Nicht verfügbare Varianten ausblenden
 *
 * iOS-kompatibel: Entfernt Optionen komplett aus dem DOM,
 * da iOS Safari/Chrome `display:none` und `hidden` auf <option>
 * ignoriert (native Picker-UI).
 *
 * Funktioniert auch wenn das Theme die erste Option als
 * <input type="hidden"> statt als <select> rendert (Einzelwert).
 */
(function () {
  'use strict';

  var debounceTimer = null;

  function processSelect(select) {
    var toRemove = [];
    var previousValue = select.value;

    Array.from(select.options).forEach(function (opt) {
      if (opt.disabled) {
        toRemove.push(opt);
      }
    });

    if (toRemove.length === 0) return;

    toRemove.forEach(function (opt) {
      opt.parentNode.removeChild(opt);
    });

    // Prüfen ob die vorher gewählte Option noch existiert
    var stillExists = Array.from(select.options).some(function (opt) {
      return opt.value === previousValue && !opt.disabled;
    });

    if (!stillExists && select.options.length > 0) {
      var firstAvailable = Array.from(select.options).find(function (o) {
        return !o.disabled;
      });
      if (firstAvailable) {
        select.value = firstAvailable.value;
        firstAvailable.selected = true;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function processAllForms() {
    // Jeden Select im Variant Picker prüfen, der disabled Optionen hat
    var selects = document.querySelectorAll('.variant-picker__form .variant-option__select');
    selects.forEach(function (select) {
      processSelect(select);
    });
  }

  var processing = false;

  function safeProcess() {
    if (processing) return;
    processing = true;
    try {
      processAllForms();
    } finally {
      setTimeout(function () { processing = false; }, 50);
    }
  }

  function init() {
    // 1. Sofort beim Laden ausführen
    safeProcess();

    // 2. Globaler MutationObserver auf stabilem Container
    var firstPicker = document.querySelector('variant-picker') ||
                      document.querySelector('.variant-picker__form');
    var target = document.body;
    if (firstPicker) {
      target = firstPicker.closest('[id^="shopify-section"], [id^="MainProduct"], main') || document.body;
    }

    var observer = new MutationObserver(function () {
      if (processing) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(safeProcess, 50);
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled']
    });

    // 3. Change-Events im Variant Picker
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.variant-picker__form')) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(safeProcess, 120);
      }
    });

    // 4. Shopify Custom Events
    document.addEventListener('variant:change', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(safeProcess, 50);
    });
    document.addEventListener('variant:changed', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(safeProcess, 50);
    });
    document.addEventListener('on:variant:change', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(safeProcess, 50);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();